var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.12 3.95662C16.12 3.42831 15.711 3 15.2064 3H15.2053C14.7013 3 14.2923 3.42831 14.2923 3.95662V8.32836L10.9262 4.81123C10.5691 4.43807 9.99068 4.43877 9.63426 4.81278L9.63352 4.81356C9.27748 5.18718 9.27808 5.79284 9.6352 6.16599L12.9705 9.65092L7.91416 9.64653C7.40943 9.64609 7.00042 10.074 7 10.6024V10.6035C6.99958 11.1313 7.40791 11.5599 7.91264 11.5604L13.0116 11.5648L9.64706 15.1002C9.29094 15.4744 9.29197 16.0801 9.64938 16.453L9.65014 16.4539C10.0072 16.8265 10.5856 16.8254 10.9417 16.4512L14.2923 12.9304V22.1606L12.4292 22.159C11.9249 22.1585 11.5156 22.5864 11.5152 23.1149V23.1159C11.5147 23.6438 11.9234 24.0724 12.4277 24.0728L14.2923 24.0744V26.0434C14.2923 26.5717 14.7013 27 15.2053 27H15.2064C15.711 27 16.12 26.5717 16.12 26.0434V24.0761L17.9042 24.0775C18.4087 24.078 18.8181 23.6501 18.8184 23.1222L18.8186 23.1212C18.8189 22.5929 18.4102 22.1641 17.9057 22.1637L16.12 22.1622V12.9418L19.4667 16.4385C19.8237 16.8117 20.4021 16.8111 20.7582 16.4375L20.7589 16.4366C21.1154 16.0627 21.1148 15.457 20.7577 15.0838L17.3933 11.5686L22.4494 11.573C22.9538 11.5735 23.3632 11.1455 23.3636 10.6177V10.6166C23.3641 10.0882 22.9553 9.65962 22.4509 9.65918L17.4096 9.65478L20.7454 6.14955C21.1015 5.77534 21.1005 5.16969 20.7434 4.79713L20.7427 4.79634C20.3853 4.42338 19.8069 4.4244 19.4507 4.79861L16.12 8.29854V3.95662Z",
    fill: "url(#paint0_linear_4836_27799)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4836_27799",
    x1: 15.1818,
    y1: 3.73666,
    x2: 15.1818,
    y2: 25.8364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC7BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuno);
export default __webpack_public_path__ + "static/media/juno.d5e0d7f85906b7d2f6defc16d74f6da4.svg";
export { ForwardRef as ReactComponent };